export default __webpack_public_path__ + "static/short-statement-do-53b31a578718d35271d468003ee5fe1e14ba83081811fd79fea3bef62f4daefe.png";